const components = [
  'header',
  'sidebar',
  'breadcrumb',
  'dynamicTable',
  'panel',
  'dropdown',
  'sideMenu',
  'echarts',
  'carousel',
  'card',
  'alarmlist',
  'report',
  'label'
  
]
var vueComps = []
for (let comp of components) {
  var rs = require('./' + comp + '/index.js')
  vueComps.push(rs.default)
}

const install = function (Vue) {
  console.info(vueComps)
  vueComps.forEach(component => {
    if (Array.isArray(component)) {
      component.forEach((item, index) => {
        Vue.component(item.name, item);
      })
    } else {
      Vue.component(component.name, component);
    }
  });
}
/* istanbul ignore if */
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

export default {
  version: "1.0",
  install,
  vueComps
}



// WEBPACK FOOTER //
// ./src/components/index.js